export default "__VITE_ASSET__Djba1PSE__"